export default __webpack_public_path__ + "static/media/latest.65238ab4.png";